/** =======================================================
 * Gtag 플러그인 규칙
 * 1. 이벤트명과 함수명은 동일하게 작성한다.
 * ========================================================= */
export const GA_EVENT_LIST = {
  LOGIN_SIGNUP_VIEW: 'login_signup_view',
  LOGIN: 'login',
  LOGOUT: 'logout',
  LOGIN_CLICK: 'login_click',
  SIGN_UP_START: 'sign_up_start',
  SIGN_UP: 'sign_up',
  NAV_CATEGORY_CLICK: 'nav_category_click',
  SEARCH_INPUT: 'search_input',
  SEARCH_CATEGORY_CLICK: 'search_category_click',
  SEARCH_EXECUTE: 'search_execute',
  LANGUAGE_CHANGE: 'language_change',
  ALL_WORKFLOW_VIEW: 'all_workflow_view',
  WORKFLOW_CARD_VIEW: 'workflow_card_view',
  WORKFLOW_CARD_CLICK: 'workflow_card_click',
  WORKFLOW_CARD_SHARE_CLICK: 'workflow_card_share_click',
  WORKFLOW_CARD_FAVORITE_CLICK: 'workflow_card_favorite_click',
  WORKFLOW_CARD_RUN_CLICK: 'workflow_card_run_click',
  BANNER_CLICK: 'banner_click',
  CATEGORY_TAB_CLICK: 'category_tab_click',
  SUB_CATEGORY_TAB_CLICK: 'sub_category_tab_click',
  SORT_CHANGE: 'sort_change',
  SORT_TIME_FILTER_CHANGE: 'sort_time_filter_change',
  BASIC_WORKFLOW_LIST_VIEW: 'basic_workflow_list_view',
  BASIC_WORKFLOW_GUIDE_CLICK: 'basic_workflow_guide_click',
  YOUTUBE_COMMUNITY_VIEW: 'youtube_community_view',
  YOUTUBE_SEARCH_INPUT: 'youtube_search_input',
  YOUTUBE_SEARCH_FILTER_CHANGE: 'youtube_search_filter_change',
  YOUTUBE_SEARCH_EXECUTE: 'youtube_search_execute',
  YOUTUBE_VIDEO_CARD_VIEW: 'youtube_video_card_view',
  YOUTUBE_VIDEO_CARD_CLICK: 'youtube_video_card_click',
  PROFILE_VIEW: 'profile_view',
  PROFILE_TAB_CLICK: 'profile_tab_click',
  PROFILE_EDIT_AVATAR_CLICK: 'profile_edit_avatar_click',
  PROFILE_EDIT_NAME_CLICK: 'profile_edit_name_click',
  PROFILE_EDIT_NAME_SAVE: 'profile_edit_name_save',
  PROFILE_EXTERNAL_LINK_CLICK: 'profile_external_link_click',
  PROFILE_WORKFLOW_CREATE_NEW_CLICK: 'profile_workflow_create_new_click',
  PROFILE_WORKFLOWFILE_NEW_FOLDER_CLICK:
    'profile_workflowfile_new_folder_click',
  PROFILE_WORKFLOWFILE_FOLDER_CLICK: 'profile_workflowfile_folder_click',
  PROFILE_GALLERY_UPLOAD_CLICK: 'profile_gallery_upload_click',
  PROFILE_IMAGEFILE_CREATE_NEW_CLICK: 'profile_imagefile_create_new_click',
  ACCOUNT_VIEW: 'account_view',
  ACCOUNT_PLAN_PURCHASE_CLICK: 'account_plan_purchase_click',
  ACCOUNT_CREDITS_PURCHASE_CLICK: 'account_credits_purchase_click',
  ACCOUNT_NAV_PLAN_MANAGE_CLICK: 'account_nav_plan_manage_click',
  ACCOUNT_NAV_PAYMENT_METHOD_CLICK: 'account_nav_payment_method_click',
  ACCOUNT_NAV_COUPON_CLICK: 'account_nav_coupon_click',
  ACCOUNT_NAV_PAYMENT_HISTORY_CLICK: 'account_nav_payment_history_click',
  ACCOUNT_NSFW_TOGGLE: 'account_nsfw_toggle',
  PLAN_MANAGE_VIEW: 'plan_manage_view',
  PAYMENT_METHOD_VIEW: 'payment_method_view',
  PAYMENT_METHOD_ADD_CLICK: 'payment_method_add_click',
  PAYMENT_METHOD_ADD_VIEW: 'payment_method_add_view',
  PAYMENT_METHOD_INPUT_CARDNUMBER: 'payment_method_input_cardnumber',
  PAYMENT_METHOD_ADD_SUBMIT: 'payment_method_add_submit',
  PAYMENT_METHOD_DELETE_CLICK: 'payment_method_delete_click',
  COUPON_VIEW: 'coupon_view',
  COUPON_CODE_INPUT: 'coupon_code_input',
  COUPON_CODE_SUBMIT: 'coupon_code_submit',
  PAYMENT_HISTORY_VIEW: 'payment_history_view',
  PAYMENT_HISTORY_ITEM_CLICK: 'payment_history_item_click',
  DETAIL_VIEW: 'detail_view',
  EASYAPP_RUN_CLICK: 'easyapp_run_click',
  OPEN_CLICK: 'open_click',
  FAVORITE_CLICK: 'favorite_click',
  SHARE_CLICK: 'share_click',
  DOWNLOAD_CLICK: 'download_click',
  IMAGE_GENERATOR_VIEW: 'image_generator_view',
  IMAGE_PROMPT_INPUT_START: 'image_prompt_input_start',
  IMAGE_MODEL_CHANGE: 'image_model_change',
  IMAGE_GENERATE_CLICK: 'image_generate_click',
  VIDEO_GENERATOR_VIEW: 'video_generator_view',
  VIDEO_PROMPT_INPUT_START: 'video_prompt_input_start',
  VIDEO_MODEL_CHANGE: 'video_model_change',
  VIDEO_GENERATE_CLICK: 'video_generate_click',
  COMFYUI_LOGIN_CLICK: 'comfyui_login_click',
  COMFYUI_LOGIN: 'comfyui_login',
  COMFYUI_LOGIN_SUCCESS: 'comfyui_login_success',
  COMFYUI_INSTALL_REQUEST_CLICK: 'comfyui_install_request_click',
  COMFYUI_MANAGER_CLICK: 'comfyui_manager_click',
  COMFYUI_GUIDEBOOK_CLICK: 'comfyui_guidebook_click',
  COMFYUI_RUN_CLICK: 'comfyui_run_click',
  COMFYUI_PURCHASE_CLICK: 'comfyui_purchase_click'
}

class GtagImpl {
  static ga_event(event_name: string, params: Record<string, unknown>) {
    if (import.meta.env.MODE !== 'prod') {
      console.warn(`[GA Event] ${event_name}`, params)
      return
    }
    window.gtag?.('event', event_name, params)
  }

  // 사용자 속성 설정 (이후 발생하는 모든 이벤트에 적용됨)
  static ga_set(params: Record<string, unknown>) {
    if (import.meta.env.MODE !== 'prod') {
      console.warn(`[GA Set]`, params)
      return
    }
    window.gtag?.('set', params)
  }
  static set_user_id(user_id: string | null) {
    this.ga_set({ user_id })
  }

  static set_is_logged_in(is_logged_in: boolean) {
    this.ga_set({ is_logged_in })
  }

  static set_price_type(price_type: 'free' | 'credit' | 'subscription' | null) {
    this.ga_set({ price_type })
  }

  static set_login_method(method: 'google' | 'discord' | null) {
    this.ga_set({ login_method: method })
  }

  static set_signup_method(method: 'google' | 'discord' | null) {
    this.ga_set({ signup_method: method })
  }

  static create_location() {
    return window.location.pathname + window.location.search
  }

  /** =======================================================
   *
   * ========================================================= */

  static comfyui_login_click({ provider }: { provider: 'google' | 'discord' }) {
    this.ga_event(GA_EVENT_LIST.COMFYUI_LOGIN_CLICK, {
      provider
    })
  }

  static comfyui_login({
    user_id,
    price_type
  }: {
    user_id: string
    price_type: 'free' | 'credit' | 'subscription' | null
  }) {
    this.set_user_id(user_id)
    this.set_price_type(price_type)
    this.set_is_logged_in(true)
  }

  static comfyui_login_success({
    provider
  }: {
    provider: 'google' | 'discord'
  }) {
    this.set_login_method(provider)
    this.ga_event(GA_EVENT_LIST.COMFYUI_LOGIN_SUCCESS, {
      provider,
      login_method: provider
    })
  }

  static comfyui_install_request_click() {
    this.ga_event(GA_EVENT_LIST.COMFYUI_INSTALL_REQUEST_CLICK, {})
  }

  static comfyui_manager_click() {
    this.ga_event(GA_EVENT_LIST.COMFYUI_MANAGER_CLICK, {})
  }

  static comfyui_guidebook_click() {
    this.ga_event(GA_EVENT_LIST.COMFYUI_GUIDEBOOK_CLICK, {})
  }

  static comfyui_run_click({ batch_count }: { batch_count: number }) {
    this.ga_event(GA_EVENT_LIST.COMFYUI_RUN_CLICK, {
      batch_count
    })
  }

  static comfyui_purchase_click() {
    this.ga_event(GA_EVENT_LIST.COMFYUI_PURCHASE_CLICK, {})
  }
}

export const Gtag = GtagImpl
